import hotelDetailReducer from './hotel-detail/reducer';
import bookingReducer from './booking/reducer';
import roomRateReducer from './room-rate/reducer';

export default ({ hotel, booking, roomRate }, action) => ({
  hotel: hotelDetailReducer(hotel, action),
  booking: bookingReducer(booking, action),
  roomRate: roomRateReducer(roomRate, action),
});
